import hexToRgba from "./hex-to-rgba";

/**
 *
 * @param {String} input
 * @param {String} separator
 */
const processHEX = (input, separator) => {
  const sliced = input.slice(1);

  if (/^[a-zA-Z0-9]+$/.test(sliced)) {
    return hexToRgba(sliced, separator);
  } else {
    return input;
  }
}

export default processHEX;